import VMasker from 'vanilla-masker';

export const unMask = ({ value, maskPattern }) => {
  if (!value) return value;

  let valCopy = [value].map((val) => val)[0];
  const maskCopy = [maskPattern].map((val) => val)[0];

  maskCopy
    .replace(/9|S/g, '')
    .split('')
    .forEach((character) => {
      valCopy = valCopy.replace(character, '');
    });

  return valCopy;
};

export const mask = ({ value, maskPattern }) => {
  if (!value) return value;
  return VMasker.toPattern(value, maskPattern);
};
